import React, { useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";

import { ReactComponent as TicketIcon } from "../../../../assets/ticket-icon.svg";
import { ReactComponent as UsersIcon } from "../../../../assets/users 01.svg";
import { ReactComponent as DownloadIcon } from "../../../../assets/download.svg";
import { eventAttendeeData } from "../../../../constants/EventAttendeeData";
import TablePagination from "./TablePagination";
import httpServices from "../../../../services/httpServices";

import SurveyDetails from "./SurveyDetails";
import { useUser } from "../../../../context/UserContext";
import formatDate from "../../../../utils/dateFormater";
import CustomSelect from "../../../../component/common/CustomSelect";
import { debounce } from "lodash";

export const CardAnalayticsData = [
  {
    title: "Ticket Sales",
    stats: "AED 74,231",
    icon: <TicketIcon />,
  },
  {
    title: "Invitees",
    stats: "865",
    icon: <UsersIcon />,
  },
  {
    title: "Attendees",
    stats: "865",
    icon: <UsersIcon />,
  },
  {
    title: "Ticket Sold",
    stats: "231",
    icon: <TicketIcon />,
  },
];

const Ageoptions = Array.from(Array(80).keys()).map((i) => ({
  label: i + 18,
  value: i + 18,
}));
const Genderoptions = [
  { label: "Male", value: "MALE" },
  { label: "Female", value: "FEMALE" },
  { label: "Other", value: "OTHER" },
];

const SignleEventAnalaytics = () => {
  const { title, id } = useParams();
  const { user } = useUser();
  const [analyticsData, setAnalyticsData] = useState(null);
  const [surveyData, setSurveyData] = useState(null);
  const [attendeesData, setAttendeesData] = useState(null);
  const [selectedAge, setSelectedAge] = useState("");
  const [selectedGender, setSelectedGender] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);

  const debouncedSearchName = debounce((value) => {
    setDebouncedSearch(value);
  }, 2000);

  const getEventAnalytics = async () => {
    try {
      const { response, error } = await httpServices.get(
        `/event/analytics/details/${id}`
      );
      if (error) throw error;

      if (response?.status === 200) {
        setAnalyticsData(response.data?.data);
      }
    } catch (error) {
      console.error("Error fetching event analytics", error);
    }
  };

  const getEventSurvey = async () => {
    try {
      const { response, error } = await httpServices.get(
        `/eventSurveyDetails/details/byEventId/${id}`
      );
      if (error) throw error;

      if (response?.status === 200) {
        setSurveyData(response.data?.data);
      }
    } catch (error) {
      console.error("Error fetching event survey", error);
    }
  };

  const getAttendees = async () => {
    try {
      const { response, error } = await httpServices.get(
        `guestDetails/by/event/${id}?page=${page}&limit=${limit}&age=${selectedAge}&gender=${selectedGender}&name=${debouncedSearch}`
      );
      if (error) throw error;

      if (response?.status === 200) {
        console.log(
          "Response from getAttendees",
          response.data?.data?.totalData
        );
        setAttendeesData(response.data?.data);
      }
    } catch (error) {
      console.error("Error fetching attendees", error);
    }
  };

  useEffect(() => {
    if (user) {
      getEventAnalytics();
      getEventSurvey();
    }
  }, [id, user]);

  useEffect(() => {
    getAttendees();
  }, [id, page, limit, selectedAge, selectedGender, debouncedSearch]);

  const [stats, setStats] = useState({
    series: [44, 55],
    options: {
      chart: {
        width: "auto",
        type: "donut",
      },
      labels: ["Male", "Female"],
      colors: ["#001752", "#306BFF"],
      dataLabels: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          customScale: 0.9,
        },
      },
      responsive: [
        {
          breakpoint: 380,
          options: {
            chart: {
              width: 280,
            },
            legend: {
              offsetX: 20,
            },
          },
        },
      ],

      legend: {
        position: "right",
        offsetY: -20,
        offsetX: -20,
        height: "auto",
        markers: {
          size: 7,
          shape: "square",
          radius: 2,
        },
        radius: 2,
        itemMargin: {
          horizontal: 20,
        },
      },
    },
  });

  const agestats = {
    series: [20, 30, 40, 50],
    options: {
      chart: {
        // width: "auto",
        type: "donut",
      },
      plotOptions: {
        pie: {
          // size: 190,
          customScale: 0.8,
          // donut: {
          //   size: '65%'
          // }
        },
      },
      responsive: [
        {
          breakpoint: 380,
          options: {
            chart: {
              width: 260,
            },
            plotOptions: {
              pie: {
                // size: 190,
                customScale: 1,
                // donut: {
                //   size: '65%'
                // }
              },
            },
            legend: {
              offsetX: 0,
            },
          },
        },
      ],

      labels: ["18 - 24", "25 - 30", "31 - 40", "41 - 50"],
      colors: ["#001752", "#306BFF", "#263238", "#2E3E8D"],
      dataLabels: {
        enabled: false,
      },
      legend: {
        position: "right",
        offsetY: -20,
        offsetX: -10,
        height: "auto",
        markers: {
          size: 7,
          shape: "square",
          radius: 2,
        },
      },
    },
  };

  return (
    <>
      <div className="bg-[#F5F6FA] w-full rounded-[10px] p-[10px] xs:p-[16px] mt-[16px] min-h-[728px]">
        <div className="grid sm:grid-cols-2 grid-cols-1 lg:grid-cols-3  xl:grid-cols-4 gap-[16px] border-b border-b-[#C1CAE1] pb-[20px]">
          <AnalayticsCard
            title={"Ticket Sales"}
            stats={
              analyticsData?.ticketSales?.value +
              " " +
              analyticsData?.ticketSales?.unit
            }
            icon={<TicketIcon />}
          />
          <AnalayticsCard
            title={"Invitees"}
            stats={analyticsData?.guestDetails}
            icon={<UsersIcon />}
          />
          <AnalayticsCard
            title={"Attendees"}
            stats={analyticsData?.attendees}
            icon={<UsersIcon />}
          />
          <AnalayticsCard
            title={"Ticket Sold"}
            stats={analyticsData?.ticketSold}
            icon={<TicketIcon />}
          />
        </div>

        <div className="flex w-full justify-between items-start mt-[20px] gap-[20px] flex-wrap lg:!flex-nowrap">
          <div className="w-full lg:w-[64%] xl:w-[69%]  rounded-[10px] bg-white min-h-[562px] py-[16px] px-[10px] xs:px-[20px]">
            <div className="flex-wrap sm:gap-0 gap-2 flex items-center justify-between">
              <h1 className="gradient-text font-semibold text-xl">Attendee</h1>

              <div className="flex flex-wrap items-center gap-[10px]">
                <CustomSelect
                  options={Ageoptions}
                  onChange={(selected) => {
                    console.log(selected);
                    setSelectedAge(selected);
                  }}
                  value={selectedAge}
                />
                <CustomSelect
                  options={Genderoptions}
                  onChange={(selected) => {
                    console.log(selected);
                    setSelectedGender(selected);
                  }}
                  value={selectedGender}
                />

                <div className="relative w-full sm:!order-last order-first xs:w-[252px]">
                  <input
                    type="text"
                    onChange={(e) => debouncedSearchName(e.target.value)}
                    placeholder="Search user"
                    className="custom-input rounded-[10px] bg-[#F5F6FA] w-full placeholder:text-[#06152B] mt-0 text-[#06152B]"
                  />
                  <div className="absolute right-5 top-1/2 translate-y-[-50%]">
                    <img src="/images/search.svg" alt="icon" />
                  </div>
                </div>
              </div>
            </div>
            <div className="overflow-x-auto">
              <table
                className="table-auto border-separate w-full"
                style={{ borderSpacing: "0 10px" }}
              >
                <thead className="table-text">
                  <tr>
                    <th className="pt-[20px] pr-5 whitespace-nowrap">
                      <div className="font-normal text-xs text-[#06152B] text-left pl-[10px] sm:pl-[46px]">
                        Full Name
                      </div>
                    </th>
                    <th className="pt-[20px] pr-5 whitespace-nowrap">
                      <div className="font-normal text-xs text-[#06152B] text-left pl-[10px] ">
                        Mobile Number
                      </div>
                    </th>
                    <th className="pt-[20px] pr-5 whitespace-nowrap">
                      <div className="font-normal text-xs text-[#06152B] text-left pl-[10px] ">
                        Email
                      </div>
                    </th>
                    <th className="pt-[20px] pr-5 whitespace-nowrap">
                      <div className="font-normal text-xs text-[#06152B] text-left pl-[10px] ">
                        Age
                      </div>
                    </th>
                    <th className="pt-[20px] pr-5 whitespace-nowrap">
                      <div className="font-normal text-xs text-[#06152B] text-left pl-[10px] ">
                        Gender
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody className=" text-sm divide-y divide-gray-100">
                  {attendeesData?.data?.length === 0 && (
                    <tr>
                      <td colSpan={"5"} className="text-center py-4 h-[100px]">
                        No Guest found
                      </td>
                    </tr>
                  )}
                  {attendeesData?.data.map((attendee) => (
                    <tr key={attendee.email} className="bg-[#F5F6FA]">
                      <td className="whitespace-nowrap pr-5 mt-[10px] pl-[15px] sm:pl-[46px] rounded-l-[10px]">
                        <div className="flex items-center py-[20px]">
                          <h5 className="table-text pb-0 text-xs sm:text-sm">
                            {attendee.guestName}
                          </h5>
                        </div>
                      </td>
                      <td className="whitespace-nowrap pr-5 mt-[10px] pl-[10px] ">
                        <div className="flex items-center py-[20px]">
                          <h5 className="table-text pb-0 text-sm">
                            {attendee.guestPhoneNumber}
                          </h5>
                        </div>
                      </td>
                      <td className="whitespace-nowrap pr-5 mt-[10px] pl-[10px]  ">
                        <div className="flex items-center py-[20px]">
                          <h5 className="table-text pb-0 text-sm ">
                            {attendee.guestEmail}
                          </h5>
                        </div>
                      </td>
                      <td className="whitespace-nowrap pr-5 mt-[10px] pl-[10px]  ">
                        <div className="flex items-center py-[20px]">
                          <h5 className="table-text pb-0 text-sm">
                            {attendee.guestAge}
                          </h5>
                        </div>
                      </td>
                      <td className="whitespace-nowrap pr-5 mt-[10px] rounded-r-[10px] pl-[10px]">
                        <div className=" py-[20px]">
                          <h5 className="table-text pb-0 text-sm">
                            {attendee.guestGender}
                          </h5>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="flex items-end flex-wrap sm:!flex-nowrap gap-4 sm:!gap-0">
              <div className="flex items-center gap-3">
                <h5 className="text-sm text-black">Entries</h5>
                <select
                  name=""
                  id=""
                  className="custom-input rounded-[10px] w-fit bg-[#F5F6FA] text-xs text-[#06152B] px-3 py-[10px]"
                >
                  <option value="">{limit}</option>
                </select>
              </div>

              <div className="self-end mt-[30px] sm:!order-last !order-first flex flex-col items-center w-full">
                <h1 className="text-center mb-[10px] text-[10px] text-black">
                  Showing 1 to {limit} of {attendeesData?.totalData}
                </h1>
                <TablePagination
                  setPage={setPage}
                  page={page}
                  limit={limit}
                  setLimit={setLimit}
                  totalPages={attendeesData?.totalData}
                />
              </div>
            </div>
          </div>

          <div className="w-full lg:w-[34%] xl:w-[29%]">
            {stats ? (
              <>
                <div className="w-full lg:w-[331px] xl:w-full xs:h-[194px] py-[14px] !px-[10px] xs:!px-[20px] rounded-[10px] bg-white">
                  <h1 className="gradient-text text-lg font-medium">Survey</h1>

                  <div className="bg-[#F5F6FA] h-[112px] w-full xs:w-[291px] lg:w-full rounded-[10px] mt-[21px] py-[16px] px-[14px]">
                    <h2 className="text-[#263238] text-sm font-medium mb-[4px]">
                      {surveyData?.surveyName || "Dummy Survey name"}
                    </h2>
                    <p className="text-[#626570] text-xs ">
                      Published on{" "}
                      {formatDate(surveyData?.createdAt) || "12 / 10 /2001"}
                    </p>

                    <div
                      className="flex items-center gap-[5px] mt-[17px]"
                      onClick={() => setStats(false)}
                    >
                      <DownloadIcon />
                      <p className="text-dark-blue  text-xs font-medium">
                        Download Report
                      </p>
                    </div>
                  </div>
                </div>

                <SurveyDetails title={"Customers"} data={stats} />
                <SurveyDetails title={"Age Group"} data={agestats} />
              </>
            ) : (
              <div className="w-full lg:w-[331px] xl:w-full xs:h-[331px] py-[16px] xs:py-[28px] !px-[10px] xs:px-[24px] rounded-[10px] bg-white">
                <h1 className="text-center w-full text-[#11263C] font-semibold">
                  Create Survey to get your customer feedback
                </h1>

                <div className="flex justify-center mt-[40px] mb-[30px]">
                  <img src="/images/illustration.png" alt="img" />
                </div>
                <NavLink
                  to={`/events/${id}/survey`}
                  className={
                    "text-center !underline text-dark-blue text-xs w-full"
                  }
                >
                  Create Survey
                </NavLink>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

function AnalayticsCard({ title, icon, stats }) {
  return (
    <div className="flex gap-3 items-center bg-white p-[14px] xs:p-[18px] rounded-[16px]">
      <div className="bg-[#F4F6FA] p-[15.35px] rounded-[8.35px]">{icon}</div>
      <div>
        <p className="text-[#9CA5B9]  text-xs">{title}</p>
        <span className="text-[#0F2950] text-lg font-medium mt-[4px]">
          {stats}
        </span>
      </div>
    </div>
  );
}

export default SignleEventAnalaytics;
